//for adding commas in price
function numberWithCommas(x: number) {
  return x.toLocaleString();
}

export default numberWithCommas;
